import React from 'react';
import classNames from 'classnames';
import { BarChart } from '../../chart';
import './details-chart.scss';

const Population = ({ data, height, modifiers, heading }) => {

    if (!data) return null;

    return (
        <div className={classNames({
            'details-scb-chart': true,
            ...modifiers
        })}>
            {!heading &&
                <>
                    <h2 className="details-scb-chart__heading">{data.title}</h2>
                    <p className="details-scb-chart__value">Antal invånare: {data.total.toLocaleString('sv')} st</p>
                </>
            }

            {heading &&
                <h2 className="details-scb-chart__heading details-scb-chart__heading--margin">{heading}</h2>
            }
            
            <div className="details-scb-chart__graph">
                <BarChart 
                    height={height}
                    valueLabel="Antal personer:"
                    unit="st"
                    total={data.total}
                    totalLabel="Andel:"
                    data={data.dataItems.map(item => {
                        return {
                            name: item.title,
                            data: item.value
                        }
                    })} dataKeys={[
                        {
                            key: 'set1', 
                            background: '#c34353'
                        },
                        {
                            key: 'set2', 
                            background: '#f2b146'
                        },
                        {
                            key: 'set3', 
                            background: '#83b69c'
                        },
                        {
                            key: 'set4', 
                            background: '#0b3358'
                        },
                        {
                            key: 'set5', 
                            background: '#726454'
                        },
                        {
                            key: 'set6', 
                            background: '#79bafa'
                        },
                        {
                            key: 'set7', 
                            background: '#222'
                        }
                    ]} />
            </div>
        </div>
    );
};

export default Population;